export default [
  {
    title: 'About',
  },
  {
    title: 'Projects',
  },
  {
    title: 'Team',
  },
  {
    title: 'Contact',
  },
];



// WEBPACK FOOTER //
// ./src/data/nav.js